import { render, staticRenderFns } from "./productSpecification.vue?vue&type=template&id=f74210d2&scoped=true&"
import script from "./productSpecification.vue?vue&type=script&lang=js&"
export * from "./productSpecification.vue?vue&type=script&lang=js&"
import style0 from "./productSpecification.vue?vue&type=style&index=0&id=f74210d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74210d2",
  null
  
)

export default component.exports